/**
 * 프로필용 ui-avatars.com 합성 이미지 URL인지 (실사진·Storage URL과 구분)
 */
export function isUiAvatarsPlaceholderUrl(url: string): boolean {
  return /ui-avatars\.com/i.test(url);
}

/** ui-avatars `name` 파라미터용: 계정 이메일의 앞 2글자 (없으면 ??) */
export function getAvatarInitialsFromEmail(email: string | undefined | null): string {
  const raw = (email || '').trim();
  if (raw.length >= 2) return raw.slice(0, 2);
  if (raw.length === 1) return `${raw}?`;
  return '??';
}

/**
 * 프로필 이미지가 없을 때(또는 예전 ui-avatars 기본값일 때) 사용하는 placeholder.
 * 일반·다크 동일: 메인 테마 초록(#10504A) 배경 + 흰색 글자
 */
export function getUiAvatarPlaceholderUrl(label: string, options?: { size?: number }): string {
  const size = options?.size ?? 128;
  const name = encodeURIComponent((label || '?').trim() || '?');
  return `https://ui-avatars.com/api/?name=${name}&background=10504A&color=fff&size=${size}&bold=true`;
}
